import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorMutationKeys } from '../../../keys'
import { CreateMemberRequest, CreateMemberResponse } from '../../../type'
import { createMember } from '../../services'

export default function useMutationCreateMember(
	props?: UseBaseMutationOptions<CreateMemberResponse, CreateMemberRequest>,
) {
	return useMutation({
		mutationKey: [OperatorMutationKeys.CreateMember],
		mutationFn: (params) => createMember(params),
		...props,
	})
}
